export const deletePOI = async (
  auth: string,
  poiId: number
): Promise<string> => {
  const { REACT_APP_API_URL } = process.env;
  try {
    const response = await fetch(`${REACT_APP_API_URL}/localpoi/${poiId}`, {
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json',
        Authorization: auth,
      },
    });

    if (response.ok) {
      return 'Local POI removed successfully';
    } else {
      const data = await response.json();
      return data.message || 'Error deleting Local POI';
    }
  } catch (error) {
    return (error as Error).message || 'Unknown error';
  }
};
